<div [formGroup]="form">
    <mat-form-field *ngIf="useSelects.includes('notificationGroup')" appearance="fill" class="w-full">
        <mat-label>Grupo de Notificación</mat-label>
        <mat-select formControlName="notificationGroupId" placeholder="Seleccione un Grupo de Notificación" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(notificationGroupList, form.get('notificationGroupId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchNotificationGroup" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar Grupo de Notificación..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterNotificationGroup($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let notificationGroup of filteredNotificationGroupList" [value]="notificationGroup._id">
                {{ notificationGroup.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="useSelects.includes('notificationMember')" appearance="fill" class="w-full">
        <mat-label>Miembro de Notificación</mat-label>
        <mat-select formControlName="notificationMemberId" placeholder="Seleccione un Miembro de Notificación" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(notificationMemberList, form.get('notificationMemberId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchNotificationMember" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar Miembro de Notificación..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterNotificationMmeber($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let notificationMember of filterednotificationMemberList" [value]="notificationMember.id">
                {{ notificationMember.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>